<template>
    <div>
        <h4 style="text-align: center">เพิ่ม / ลด ค่าเที่ยวของขนส่ง</h4>
        <br>
        <div class="row form-group">
            <div class="col text-right"><label></label></div>
            <div class="col">
               <span>Action เพิ่ม/ลด</span>
            </div>
            <div class="col">
                <span>รถใหญ่</span>
            </div>
            <div class="col">
                <span>รถบริษัท</span>
            </div>
            <div class="col">
                <span>รถเล็ก</span>
            </div>
        </div>
        <div class="row form-group">
            <div class="col text-right"><label>พุทธมณฑล</label></div>
            <div class="col">
                <b-form-select v-model="transport1.action" :options="options"></b-form-select>
            </div>
            <div class="col">
                <input type="number"
                       v-model="transport1.big_car_cost"
                       placeholder="รถใหญ่"
                       class="form-control"/>
            </div>
            <div class="col">
                <input type="number"
                       v-model="transport1.company_car_cost"
                       placeholder="รถบริษัท"
                       class="form-control"/>
            </div>
            <div class="col">
                <input type="number"
                       v-model="transport1.small_car_cost"
                       placeholder="รถเล็ก"
                       class="form-control"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col text-right"><label>ศาลายา</label></div>
            <div class="col">
                <b-form-select v-model="transport2.action" :options="options"></b-form-select>
            </div>
            <div class="col">
                <input type="number"
                       v-model="transport2.big_car_cost"
                       placeholder="รถใหญ่"
                       class="form-control"/>
            </div>
            <div class="col">
                <input type="number"
                       v-model="transport2.company_car_cost"
                       placeholder="รถบริษัท"
                       class="form-control"/>
            </div>
            <div class="col">
                <input type="number"
                       v-model="transport2.small_car_cost"
                       placeholder="รถเล็ก"
                       class="form-control"/>
            </div>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitData"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp&nbsp
            <button @click="cancelData"
                    type="button"
                    class="btn btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "edit-transport-fee-modal",
        data(){
            return {
                options : [
                    { value: null, text: 'เลือก Action' },
                    { value: 1, text: '+เพิ่ม' },
                    { value: 2, text: '-ลด' },
                ],
                transport1 : {
                    action : null,
                    big_car_cost : '',
                    company_car_cost : '',
                    small_car_cost : '',
                },
                transport2 : {
                    action : null,
                    big_car_cost : '',
                    company_car_cost : '',
                    small_car_cost : '',
                }
            }
        },
        methods : {
            cancelData(){
                this.$emit("submit",false)
                this.clearData();
            },
            submitData(){
                let data = {
                    transport1:this.transport1,
                    transport2:this.transport2,
                };
                this.$emit("submit",data);
                this.clearData();
            },
            clearData(){
                this.transport1 = {
                    action : null,
                    big_car_cost : '',
                    company_car_cost : '',
                    small_car_cost : '',
                };
                this.transport2 = {
                    action : null,
                    big_car_cost : '',
                    company_car_cost : '',
                    small_car_cost : '',
                }
            }
        }
    }
</script>

<style scoped>

</style>